import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-account-remove-outline',
  templateUrl: './icon-account-remove-outline.component.html',
  styleUrl: './icon-account-remove-outline.component.scss',
  standalone: false,
})
export class IconAccountRemoveOutlineComponent {
  @Input() tooltip?: string;
}
